import { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { FEATURES } from 'consts';
import { selectIsMeSubscribedToSummary, selectSummaryStatus } from 'state/selectors';
import { SUMMARY_STATUS } from 'state/store/summary/types';
import { useSummary } from 'useCase';
import { isFeatureOn } from 'useCase/featureFlags/featureFlagsApi';
import { InProgressSummaryButton, StartSummaryButton, StopSummaryButton } from '../SummaryButton';

interface SummaryPanelProps {
    isMobile?: boolean;
}

export const SummaryPanel = observer(({ isMobile }: SummaryPanelProps) => {
    const status = selectSummaryStatus();
    const isMeSubscribedToSummary = selectIsMeSubscribedToSummary();

    const { startSummarizer, stopSummarizer, checkOnUnavailableSummarize } = useSummary();

    const isSummaryEnabled = isFeatureOn(FEATURES.LOCAL_VCS_AI_RECAP_ENABLED)
        ? !checkOnUnavailableSummarize()
        : isFeatureOn(FEATURES.VCS_AI_RECAP_ENABLED);

    const handleStartSummarizer = useCallback(() => {
        startSummarizer();
    }, []);

    const handleStopSummarizer = useCallback(() => {
        stopSummarizer();
    }, []);

    if (!isSummaryEnabled) return null;

    if (
        (isMeSubscribedToSummary && status === SUMMARY_STATUS.WAITING_FOR_START) ||
        status === SUMMARY_STATUS.STOPPING
    ) {
        return <InProgressSummaryButton isMobile={isMobile} />;
    }

    if (isMeSubscribedToSummary && status === SUMMARY_STATUS.SUMMARIZING) {
        return <StopSummaryButton onClick={handleStopSummarizer} isMobile={isMobile} />;
    }

    return <StartSummaryButton onClick={handleStartSummarizer} isMobile={isMobile} />;
});
